import { toast, SvelteToast } from '@zerodevx/svelte-toast';

let lastShown = '';

export const success = (m: string, callback?: (id?: number) => void): number => {
  if (!canContinue(m)) return;
  toast.push(m, {
    theme: {
      '--toastBackground': '#2ecc71',
      '--toastColor': 'white',
      '--toastBarBackground': '#2ecc71',
      '--toastPadding': '10px',
      '--toastContainerRight': '0rem',
      '--toastMargin': '0 0 0.5rem 1rem',
      '--toastWidth': '100%',
    },
    onpop(id?: number): any {
      if (callback) {
        callback(id);
      }
    },
  });
};

export const danger = (m: string, callback?: (id?: number) => void): number => {
  if (!canContinue(m)) return;
  toast.push(m, {
    theme: {
      '--toastBackground': '#e74c3c',
      '--toastColor': 'white',
      '--toastBarBackground': '#e74c3c',
      '--toastPadding': '10px',
      '--toastContainerRight': '0rem',
      '--toastMargin': '0 0 0.5rem 1rem',
      '--toastWidth': '100%',
    },
    onpop(id?: number): any {
      if (callback) {
        callback(id);
      }
    },
  });
};

// During development toast sometime is shown multiple time repeatedly?!, just to be sure lets have a guard that will ignore any repeated toasts within 3 seconds
const canContinue = (m) => {
  if (lastShown === m) return false;
  lastShown = m;
  setTimeout(() => {
    lastShown = '';
  }, 3000);
  return true;
};

export { SvelteToast };
